import React from "react";
import { SpendingControlsProvider } from "./SpendingControlsContext";

const SpendingControlsProviderWrapper = ({ children }) => (
  <SpendingControlsProvider>
    {children}
  </SpendingControlsProvider>
);

export default SpendingControlsProviderWrapper;
